import React from 'react';
import get from 'lodash.get';
import { FormattedMessage, FormattedNumber } from 'react-intl';

/**
 * Filters out local pickup and multiple shipping quotes for a given list of shipping quotes.
 *
 * @param {Array} quotes - A Relay list of shipping quotes.
 * @return {Array}
 */
export const getFilteredQuotes = (quotes = []) =>
    quotes.reduce((sortedQuotes, quote) => {
        const index = sortedQuotes.findIndex(
            q =>
                get(q, 'serviceMethod.serviceType') === get(quote, 'serviceMethod.serviceType') &&
                get(q, 'serviceMethod.serviceMethodType') ===
                    get(quote, 'serviceMethod.serviceMethodType') &&
                get(q, 'serviceMethod.region.code') === get(quote, 'serviceMethod.region.code')
        );

        if (index !== -1) {
            const newQuoteAmount = get(quote, 'totalAmount.amount');
            const existingQuoteAmount = get(sortedQuotes[index], 'totalAmount.amount');
            const hasLowerAmount = newQuoteAmount < existingQuoteAmount;
            const hasSameAmount = newQuoteAmount === existingQuoteAmount;
            const is1stdibsBilledQuote = get(quote, 'is1stdibsBilledQuote');

            if (hasLowerAmount || (hasSameAmount && is1stdibsBilledQuote)) {
                sortedQuotes.splice(index, 1, quote);
            }
        } else {
            sortedQuotes.push(quote);
        }
        return sortedQuotes;
    }, []);

/**
 * Returns formatted shipping price.
 *
 * @param {Array} convertedAmountList - List of converted amounts.
 * @param {String} currency - User currency.
 * @returns {String}
 */
export const getShippingPrice = ({ convertedAmountList = [], currency }) => {
    const { amount } = convertedAmountList.find(p => p.currency === currency) || {};

    let price = (
        <FormattedNumber
            value={amount}
            style="currency"
            currency={currency}
            minimumFractionDigits={parseFloat(amount) % 1 === 0 ? 0 : 2}
        />
    );

    if (amount === 0) {
        price = <FormattedMessage id="shippingHelpers.complimentary" defaultMessage="Free" />;
    }
    return price;
};
